import NylasThankYou from './NylasThankYou';

export default NylasThankYou;
